import { Check, Loader2 } from "lucide-react";
import { useI18n } from "@/lib/i18n";
import { JOB_STEPS } from "@/lib/jobs";

export default function JobProgress({ kind, phase, dark = false }) {
  const { t } = useI18n();
  const steps = JOB_STEPS[kind];
  const cur = steps.indexOf(phase);
  return (
    <ol data-testid={`job-progress-${kind}`} className="space-y-2">
      {steps.map((s, i) => {
        const done = phase === "done" || i < cur;
        const active = i === cur || (cur === -1 && i === 0 && phase !== "done");
        return (
          <li key={s} data-testid={`job-step-${s}`} data-state={done ? "done" : active ? "active" : "pending"}
            className={`flex items-center gap-2 text-[13px] transition-opacity duration-300 ${done || active ? "opacity-100" : "opacity-40"} ${dark ? "text-zinc-200" : "text-zinc-700"}`}>
            {done ? <Check className="h-3.5 w-3.5 text-emerald-500" />
              : active ? <Loader2 className="h-3.5 w-3.5 animate-spin text-[#d4af37]" />
                : <span className="h-3.5 w-3.5 rounded-full border border-zinc-500" />}
            <span>{i + 1}/{steps.length} · {t(`job.${s}`)}</span>
          </li>
        );
      })}
    </ol>
  );
}
